import styled from "styled-components";

export const HeaderDateTime = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 0.3rem;
  background-color: #95c620;
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
`;
